import React from 'react'
import Footer from '../components/Footer'
import Header from "../components/Header"

export default function Layout(props) {
    return (
        <div className="">
            <Header></Header>
            <div className="container px-3 py-0">
                {props.children}
            </div>
            {/* <Footer></Footer> */}
        </div>
    )
}
